import { put, takeLatest } from "redux-saga/effects";
import { getBestSaleProductApi } from "store/api/HomeApi";
import { GET_BEST_SALE_ACTION } from "../../actions/HomePageAction/actionTypes";

import * as homePageAction from "../../actions/HomePageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getBestSaleProduct() {
	const res = yield getBestSaleProductApi();
	try {
		if (res?.code === 0) {
			yield put(homePageAction.setBestSale(res?.data));
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	}
}

function* getBestSaleProductSaga() {
	yield takeLatest(GET_BEST_SALE_ACTION, getBestSaleProduct);
}

export default getBestSaleProductSaga;
